import React from 'react';
import { useTranslation as originalUseTranslation } from 'react-i18next';

// Create a wrapper around useTranslation to handle types properly
export const useTranslation = () => {
  // @ts-ignore - Use the original hook but ignore TypeScript issues
  const { t, i18n, ready } = originalUseTranslation();
  
  return {
    t,
    i18n,
    ready
  };
}; 